import React, { useState } from 'react';
import {logEventOnPress} from '../../utils/AnalyticsUtil'
import PropTypes from 'prop-types';
import BaseComponent from '../BaseComponent';
import { IoEyeOutline, IoEyeSharp } from "react-icons/io5";


const TextInput = ({
  name,
  value = '',
  isError = false,
  placeholder = '',
  onChange,
  onClick,
  onKeyUp,
  onFocus,
  onBlur,
  isFloatingLabel,
  errorText = '',
  disabled = false,
  label,
  cssClass,
  id,
  isShowEyeIcon = false,
  type = 'text',
  useref,
}) => {
  const [showPassword, setShowPassword] = useState(isShowEyeIcon); 

  const handleChange = (e) => {
    !!onChange && onChange(e);
  };

  const handleClick = (e) => {
    logEventOnPress('onTextInputClick', name, value);
    !!onClick && onClick(e);
  };

  const handleKeyUp = (e) => {
    !!onKeyUp && onKeyUp(e);
  };

  const handleFocus = (e) => {
    !!onFocus && onFocus(e);
  };

  const handleBlur = (e) => {
    logEventOnPress('onTextInputClick', name, value);
    !!onBlur && onBlur(e);
  };

  return (
    <BaseComponent name={'TextInput'}>
      <div className="input-conatainer">
        {label && !isFloatingLabel ? <div className="input-label">{label}</div> : ''}
        <input
          name={name}
          type={showPassword ? "password" : type === "text" ? "text" : "number"}
          className={`inputText ${showPassword && value !== '' ? 'password-input' : ''} ${isError ? ' border-error' : ''} ${cssClass}`}
          value={value}
          placeholder={!isFloatingLabel && !label ? placeholder : ''}
          onChange={(e) => handleChange(e)}
          onClick={(e) => handleClick(e)}
          onKeyUp={(e) => handleKeyUp(e)}
          onFocus={(e) => handleFocus(e)}
          onBlur={(e) => handleBlur(e)}
          required
          disabled={disabled}
          id={id}
          autoComplete="off"
          ref={useref}
        />
        {isShowEyeIcon ? <div className='eye-open-icon' onClick={() => {logEventOnPress('onTextInputShowPasswordClicked', showPassword); setShowPassword(!showPassword)}}>{showPassword ? <IoEyeSharp /> : <IoEyeOutline /> }</div> : ''}
        {isFloatingLabel ? <span className="floating-label">{placeholder}</span> : ''}
        {isError ? <div className="color-error error-text" id="requiredError">{errorText}</div> : ''}
      </div>
    </BaseComponent>
  );
};

TextInput.propTypes = {
  value: PropTypes.string,
  errorText: PropTypes.string,
  isError: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

export { TextInput };
